<template>
  <div>
    <PersonInfo :v="v" />

    <v-checkbox
      v-model="v.isTrustee.$model"
      label="Подать заявление как представитель заявителя"
      hide-details
    />

    <PersonTrustee v-if="v.isTrustee.$model" :v="v.trustee" />
  </div>
</template>

<script>
import PersonTrustee, {
  personTrusteeModel,
  getPersonTrusteeValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/Person/PersonTrustee';
import PersonInfo, {
  personInfoModel,
  personInfoValidation,
  prefillEsiaPersonInfo,
} from '@/components/services/EgrnConfirm/Applicant/components/Person/PersonInfo';
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';

export const mrpaEnableTrusteePersonModel = {
  ...cloneDeep(personInfoModel),
  isTrustee: false,

  trustee: cloneDeep(personTrusteeModel),
};

export const getMrpaEnableTrusteePersonValidation = (person) => {
  const personValidation = {
    ...personInfoValidation,
    isTrustee: {},
  };

  if (!person.isTrustee) return personValidation;

  personValidation.trustee = getPersonTrusteeValidation(person.isTrustee);

  return personValidation;
};

export const prefillEsiaMrpaEnableTrusteePerson = async () => {
  const esiaPersonInfo = await prefillEsiaPersonInfo();

  return deepmerge(mrpaEnableTrusteePersonModel, esiaPersonInfo);
};

export default {
  name: 'MrpaEnableTrusteePerson',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    PersonInfo,
    PersonTrustee,
  },
};
</script>
